import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Tooltip as MuiTooltip } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";

var speedSwitch = function speedSwitch(_ref) {
  var variant = _ref.variant;

  switch (variant) {
    case 'fast':
      return 500;

    case 'medium':
      return 2000;

    default:
      return 500;
  }
};

export var Tooltip = function Tooltip(_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'fast' : _ref2$variant,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(MuiTooltip, _objectSpread(_objectSpread({
    componentsProps: {
      popper: {
        disablePortal: true
      }
    },
    enterDelay: speedSwitch({
      variant: variant
    }),
    leaveDelay: 200
  }, props), {}, {
    "data-element": "MuiTooltip",
    "data-component": "Tooltip",
    "data-source-file": "index.tsx"
  }));
};